"use client";

//import Banner from "src/components/Banner";
//import Card from "src/components/NavCard";
import React from "react";
import { DynamicPage, FormIdentifier, PageWithLayout } from "@shesha-io/reactjs";
import { PortalLayout } from "@shesha-io/pd-publicportal";

interface IProps {
  searchParams: NodeJS.Dict<string | string[]>;
}

const Home: PageWithLayout<IProps> = (props) => {
  const { searchParams } = props;
  const formId: FormIdentifier = {
    module: "Rsl.Crm",
    name: "landing-page",
  };
  return (
    <PortalLayout>
      <DynamicPage {...searchParams} formId={formId} />
    </PortalLayout>
  );
};

export default Home;
